<template>
  <v-row>
    <v-col cols="12" v-text="$route.name" class="mt-5 grey--text text-h2" />
    <v-col cols="12">
      <v-card>
        <v-toolbar color="blue darken-2" dark>
          <v-toolbar-title>Processos Cadastrados</v-toolbar-title>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-list two-line>
          <v-list-item-group
            v-model="selected"
            active-class="blue--text"
            multiple
          >
            <template>
              <v-col
                cols="12"
                v-for="(item, index) in processos"
                :key="item.id"
                class="pa-0 link"
              >
                <v-list-item :to="`/processos/editar/${item.id}`">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.nome"></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="item.encerrado ? '🔴 Encerrado' : '🟢 Ativo'"
                        class="text--primary"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action
                      v-if="!item.encerrado"
                      class="d-flex flex-row-reverse"
                      flat
                      tile
                    >
                      <dialog-encerrar
                        :dialog="dialogEncerrar"
                        :item="processoEncerramento"
                        @save="onConfirmEncerrar"
                        @cancel="dialogEncerrar = false"
                      />
                      <BtnPrevent
                        :deletarProcesso="'Deletar Processo'"
                        icon="mdi-text-box-remove"
                        :tooltip="'Encerrar Processo'"
                        color="green"
                        @click="onEncerrar(item)"
                      />
                    </v-list-item-action>
                    <v-list-item-action
                      class="d-flex flex-row-reverse"
                      flat
                      tile
                    >
                      <dialog-delete
                        :dialog="dialogDelete"
                        :item="processoExclusao"
                        @save="onConfirmRemove"
                        @cancel="dialogDelete = false"
                      />
                      <BtnPrevent
                        :tooltip="'Remover Processo'"
                        icon="mdi-delete"
                        color="red"
                        @click="onRemover(item)"
                      />
                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-divider
                  v-if="index < processos.length - 1"
                  :key="index"
                ></v-divider>
              </v-col>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>
    <FlyBtn
      @click="onClickNovo"
      :icon="'mdi-plus'"
      :tooltip="'Adicionar Processo'"
    />
  </v-row>
</template>

<script>
import BtnPrevent from "@/components/BtnPrevent";
import FlyBtn from "@/components/BtnFloating";
import DialogDelete from "@/pages/Processo/components/DialogDelete.vue";
import DialogEncerrar from "@/pages/Processo/components/DialogEncerrar.vue";

export default {
  components: {
    FlyBtn,
    DialogDelete,
    DialogEncerrar,
    BtnPrevent
  },

  data: () => ({
    dialogDelete: false,
    dialogEncerrar: false,
    DialogEditar: false,
    tooltip: "Adicionar Processo",
    selected: [null],
    processos: [],
    confirmarExclusao: false,
    processoExclusao: {},
    processoEncerramento: false,
    tipoUnidade: []
  }),

  mounted() {
    this.getProcessos();
  },

  methods: {
    onClickNovo() {
      const processoEmAndamento = this.processos.some(p => !p.encerrado);
      processoEmAndamento
        ? this.showMessage("Já existe um processo em andamento.", "warning")
        : this.$router.push("/processos/novo");
    },

    getProcessos() {
      this.$http
        .get("processo-inscricao")
        .then(processos => {
          this.processos = processos;
        })
        .catch(error => this.showMessage(error, "error"));
    },
    onRemover(processo) {
      this.processoExclusao = processo;
      this.dialogDelete = true;
    },
    onEncerrar(item) {
      this.processoEncerramento = item;
      this.dialogEncerrar = true;
    },

    onConfirmEncerrar() {
      this.$http
        .put(`/processo-inscricao/${this.processoEncerramento.id}`, {
          encerrado: true
        })
        .then(() => {
          this.dialogEncerrar = false;
          this.getProcessos();
          this.showMessage("Processo foi encerrado com sucesso", "success");
        })
        .catch(error => {
          this.showMessage(error, "error");
          this.loading = false;
        });
    },

    onConfirmRemove() {
      //Chamada MEthod DELETE para o backend
      this.$http
        .delete(`processo-inscricao/${this.processoExclusao.id}`)
        .then(() => {
          this.dialogDelete = false;
          this.processos = {};
          this.showMessage("Removida com sucesso.", "success");
          this.getProcessos();
        })
        .catch(error => this.showMessage(error, "error"));
    }
  }
};
</script>
